import { PanelType } from '@fluentui/react';
import { concatStyleSets, DetailsList, SelectionMode } from 'office-ui-fabric-react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataOperation_Echeancier_Stade } from '../../data/DataOperation_Echeancier_Stade';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUIPanel } from '../EUI/EUIPanel';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheAvancementTravauxCreation extends Component {

    static defaultProps = {
        isOpen: false,
        idOperation: null,
        /* --- */
        onDismiss: () => null,
        onEnregistrement: () => null
    };

    static defaultState = {
        items: [],
        groups: [],
        /* --- */
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheAvancementTravauxCreation.defaultState };
    };

    _chargementDonnees = () => {
        const { idOperation } = this.props;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement en cours..."
        });

        DataOperation_Echeancier_Stade._chargementProchainsAvancementsTravaux(idOperation)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const reponseAPIobjet = responseFetch.reponseAPIobjet || {};
                    const avancementsTravaux = reponseAPIobjet || [];
                    this._sortItems(avancementsTravaux);
                    const state = {
                        groups: this._getGroups(avancementsTravaux),
                        items: avancementsTravaux
                    };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
    };

    _enregistrer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement en cours..."
        });

        const { idOperation, onEnregistrement } = this.props;
        const { items } = this.state;
        const avancementsTravaux = items.filter(avancementTravaux => !!avancementTravaux.dateReelle);

        DataOperation_Echeancier_Stade._onEnregistrementOperation_Echeancier_Stades(idOperation, avancementsTravaux)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { ...FicheAvancementTravauxCreation.defaultState }, onEnregistrement);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _getColumns = () => {
        const aujourdhui = new Date(Date.now());
        return [
            {
                isResizable: true,
                fieldName: "nomEcheancier",
                key: "nomEcheancier",
                name: "Échéancier",
            },
            {
                key: "pourcentageAvancementTravaux",
                minWidth: 100,
                maxWidth: 100,
                name: "Avancement",
                onRender: (item) => <span>{parseFloat(item.pourcentageAvancementTravaux * 100).toFixed(2)}&nbsp;%</span>
            },
            {
                key: "pourcentageCumul",
                minWidth: 100,
                maxWidth: 100,
                name: "Cumul",
                onRender: (item) => <span>{parseFloat(item.pourcentageCumul * 100).toFixed(2)}&nbsp;%</span>
            },
            {
                key: "datePrevisionnelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date prévisionnelle",
                onRender: (item) => <span>{Scriba.date().stringDateFormatCourt(item.datePrevisionnelle)}</span>
            },
            {
                key: "dateReelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date réelle",
                onRender: (item) => <EUIDatePicker
                    data-testid="nouvelAvancement_DateReelle"
                    maxDate={aujourdhui}
                    onSelectDate={this._onSelectDate(item.idEcheancier)}
                    value={item.dateReelle}
                />
            },

        ];
    };

    _getGroups = (avancementsTravaux) => {
        const avancementsTravauxGroupesParStade = avancementsTravaux.reduce((memo, avancement) => {
            const groupName = avancement.nomStade || "ERREUR";
            if (!memo[groupName])
                memo[groupName] = [];
            memo[groupName].push(avancement);
            return memo;
        }, {});

        let groups = [];
        let startIndex = 0
        for (const [nomStade, avancementsTravaux] of Object.entries(avancementsTravauxGroupesParStade)) {
            const count = avancementsTravaux.length;
            groups.push({ key: nomStade, name: nomStade, startIndex, count });
            startIndex += count;
        };

        return groups;
    };

    _onOpen = () => {
        const { idOperation } = this.props;
        if (!!idOperation) this._chargementDonnees()
        else this.setState({ ...FicheAvancementTravauxCreation.defaultState });
    };

    _onSelectDate = (idEcheancier) => (date) => {
        let avancementsTravaux = [...this.state.items];
        let index = avancementsTravaux.findIndex(avancementTravaux => avancementTravaux.idEcheancier === idEcheancier);
        if (index >= 0) {
            date = Scriba.date().getChaineISOFromDate(date, true);
            let avancementTravaux = { ...avancementsTravaux[index] };
            if (avancementTravaux.dateReelle !== date) {
                avancementTravaux.dateReelle = date;
                avancementsTravaux.splice(index, 1);
                avancementsTravaux.push(avancementTravaux);
                this._sortItems(avancementsTravaux);
                this.setState({ items: avancementsTravaux }, this._onVerificationFormulaire);
            }
        }
    };

    _onVerificationFormulaire = () => {
        const { idOperation } = this.props;
        const { items } = this.state;
        const avancementsTravaux = items.filter(avancementTravaux => !!avancementTravaux.dateReelle);
        Immocom.fiche()._validationFormulaire(this, "AvancementsTravaux", { idOperation, avancementsTravaux }, "Modification");
    };

    _sortItems = (items) => {
        items.sort((a, b) =>
            a.nomStade.localeCompare(b.nomStade)
            || a.nomEcheancier.localeCompare(b.nomEcheancier)
        );
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { onActiveBoutonEnregistrer, items } = this.state;

        return <EUIPanel
            headerText="Nouveaux avancements travaux"
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._enregistrer}
            type={PanelType.large}
        >

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack>

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                <DetailsList
                    columns={this._getColumns()}
                    groupProps={{ showEmptyGroups: true }}
                    groups={this.state.groups}
                    items={items}
                    onRenderRow={(props, defaultRender) => {
                        const styles = concatStyleSets(props.styles, { fields: { alignItems: "center" } });
                        return defaultRender({ ...props, styles });
                    }}
                    selectionMode={SelectionMode.none}
                />

            </Stack>

        </EUIPanel>;
    };

};